export const FUTURE_FASHION_CONSTANTS = {
  /**
   * Code to identify the camera attribute
   */
  CAMERA_ATTRIBUTE_CODE: 'V1',
};

export const CUSTOMIZATION_NAMES = {
  CUSTOMIZATION_FILE_NAME: 'customizations.json',
  CUSTOMIZATION_COMMON_FOLDER: '_common',
};

export type PlatformsType = 'Android' | 'iOS';

export const PLATFORMS = {
  Android: 'Android' as PlatformsType,
  iOS: 'iOS' as PlatformsType,
};

export const CUSTOMIZATION_GROUP_CODES = {
  /**
   * Code to identify the customization group
   */
  GROUP_CODE: 'GC',
  /**
   * Code to identify the customization option
   */
  ITEM_CODE: 'OC',
};

export const OPTION_TYPE = {
  /**
   * Group, Code to identify a group of attribute
   */
  G: 'G',
  /**
   * Attribute, Code to identify an attribute or a step
   */
  A: 'A',
  /**
   * Model, Code to identify a complex option without preview
   */
  M: 'M',
  /**
   * Option, Code to identify a simple option with preview
   */
  O: 'O',
};

export const CODE_SECTION = {
  GROUP: [OPTION_TYPE.G],
  ATTRIBUTE: [OPTION_TYPE.A],
  OPTION: [OPTION_TYPE.M, OPTION_TYPE.O],
};

export const CODE_SPLIT_CHAR = {
  /**
   * Divide code from reference name
   * @example
   * 'G1#Model'
   * - G1 is the code
   * - Model is the reference name
   */
  CODE_NAME: '#',
  /**
   * Divide attribute from option name
   * @example
   * 'A1-O1#Option'
   * - A1 is the attribute code
   * - O1 is the option code
   * - Option is the reference name
   */
  ATTRIBUTE_OPTION: '-',
};

export const BULK_PRICES = {
  /**
   * Code to identify the bulk prices attribute
   */
  BULK_PRICES_ATTRIBUTE_CODE: 'A91',

  /**
   * Code to identify the bulk prices group
   */
  BULK_PRICES_GROUP_CODE: 'GBULK',
};

export const SPECIAL_OPTION = {
  NOT_SET: 'not-set',
  ZAKEKE_EMPTY_TEXT: 10240,
  INVISIBLE_GROUP: 'G99',
  INVISIBLE_GROUP_CUSTOMPRICE_ATTRIBUTE: 'A90',
};
